<template>
  <EChartsVerticalBar
    :key="reserveChartKey"
    :height="500"
    :dataset="reserveDataset"
    :labels="reserveLabels"
    :barMaxWidth="40"
    :yAxisMaxRatio="1.1"
    :formatValueFunction="formatValueFunction"
    labelColor="black"
    legendIcon="rect"
    :titleConfig="titleConfig"
  />
</template>

<script>
  import { numberFormatterWithFixedFractionDigits } from '@/common/utils/numberFormatter';

  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import Api from '../../api';

  export default {
    name: 'SufficiencyLevelChart',
    components: { EChartsVerticalBar },
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        reservesData: [],
        titleConfig: {
          text: 'Уровень достаточности международных резервов для покрытия импорта (в месяцах)',
        },
      };
    },

    created() {
      if (this.countryId) {
        this.loadData();
      }
    },

    methods: {
      loadData() {
        Api.getReservesSufficiencyValue(this.countryId).then((response) => {
          this.reservesData = response.data.reverse();
        });
      },
      formatValueFunction(value) {
        return numberFormatterWithFixedFractionDigits(value, 'ru-RU', 1);
      },
    },

    computed: {
      reserveChartKey() {
        return this.reservesData ? this.reservesData.reduce((sum, item) => sum + (item.value ?? 0), 0).toString() : '';
      },
      reserveLabels() {
        return [...this.reservesData].map((item) => String(item.year));
      },
      reserveChartData() {
        return [...this.reservesData].map((item) => item.value);
      },
      reserveDataset() {
        return [
          {
            label: 'Уровень достаточности международных резервов для покрытия импорта',
            data: this.reserveChartData,
            color: '#7cb5ec',
          },
        ];
      },
    },

    watch: {
      countryId: function () {
        this.loadData();
      },
    },
  };
</script>
